module.exports = __webpack_public_path__ + "img/valencia_camins_al_grau.acf641b7.jpg";